import { useGoldDateList } from '../hooks/useGoldDateList';
import { withResponsive, WithResponsiveProps } from '../utils/withResponsive';

import { ActionButtonsList } from './ActionButtonsList';
import { GoldList } from './GoldList';

import type { ResponseInfoFeoroUsuario } from '@/types/goldDate';

interface GoldDateListProps extends WithResponsiveProps {
  dataProps?: ResponseInfoFeoroUsuario;
}

const GoldDateListComponent = ({
  dataProps,
  isDesktop,
  isMobile,
}: GoldDateListProps) => {
  const {
    data,
    contentPresentPage,
    contentPastPage,
    handleContentPresentPage,
    handleContentLastPage,
  } = useGoldDateList({ dataProps, isDesktop });

  return (
    <>
      <div className="w-[calc(100%+2rem)] -left-4 relative lg:left-auto lg:w-auto">
        {data?.presentList && data?.presentList?.length > 0 && (
          <GoldList
            allItems={data?.presentList}
            isDesktop={isDesktop}
            isMobile={isMobile}
            items={contentPresentPage}
            prize={data?.prize}
            subtitle="Participá por $0 en cada uno"
            title="Torneos Fecha de Oro en los que estás jugando"
            onPageChange={handleContentPresentPage}
          />
        )}

        {data?.pastList && data?.pastList.length > 0 && (
          <GoldList
            allItems={data?.pastList}
            isDesktop={isDesktop}
            isMobile={isMobile}
            items={contentPastPage}
            prize={data?.prize}
            subtitle="Participaste por $0 en cada uno"
            title="Torneos Fecha de Oro en los que jugaste"
            onPageChange={handleContentLastPage}
          />
        )}
      </div>

      <ActionButtonsList
        dataProps={dataProps}
        isDesktop={isDesktop}
        isMobile={isMobile}
      />
    </>
  );
};

export const GoldListContainer = withResponsive(GoldDateListComponent);
